import { usePortalAuth } from '@nrx/auth-ui';
import { FileExchangeView, createFxFilesClient } from '@nrx/file-ui';
import { useMemo } from 'react';

export interface FileExchangePageProps {
  readonly servicesBaseUrl: string;
}

export function FileExchangePage({ servicesBaseUrl }: FileExchangePageProps): React.JSX.Element {
  const auth = usePortalAuth();
  const token = auth.user?.access_token;
  const client = useMemo(
    () => createFxFilesClient({ baseUrl: `${servicesBaseUrl}/v1`, getAuthToken: () => token }),
    [servicesBaseUrl, token],
  );
  return (
    <main className="mx-auto max-w-3xl p-6">
      <h1 className="mb-4 text-xl font-semibold text-gray-900">File Exchange</h1>
      <FileExchangeView client={client} />
    </main>
  );
}
